exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".src-source-forms-questions-informational-text-styles__root {\n  padding: 1.6rem 0;\n  font-size: 1.3rem;\n}\n", ""]);

// exports
exports.locals = {
	"root": "src-source-forms-questions-informational-text-styles__root"
};